// Copyright 2019 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { OpenIdConnectConfiguration } from "aurelia-open-id-connect";
import { Router } from "aurelia-router";

@autoinject
export class OpenIDUnauthorizedNavigationStrategy {
    private static readonly LoginRedirectKey: string = "loginRedirect";

    constructor(
        private readonly router: Router,
        private readonly configuration: OpenIdConnectConfiguration,
        private readonly $window: Window
    ) {}

    public navigate(): void {
        this.router.navigate(this.getRedirectUriString());
    }

    public getRedirectUriString(): string {
        const loginRedirect = this.getSafeLoginRedirect();
        return (
            this.configuration.unauthorizedRedirectRoute +
            `?${OpenIDUnauthorizedNavigationStrategy.LoginRedirectKey}=${loginRedirect}`
        );
    }

    public getRedirectArgs(): { [name: string]: string } {
        const args: { [name: string]: string } = {};
        args[OpenIDUnauthorizedNavigationStrategy.LoginRedirectKey] = this.getSafeLoginRedirect();
        return args;
    }

    private getSafeLoginRedirect(): string {
        // Adapted from https://github.com/aurelia-contrib/aurelia-open-id-connect/blob/master/src/open-id-connect-authorize-step.ts
        // capture the URL to which the user was originally navigating
        // include that URL in a query string parameter on the redirect
        const loginRedirect = this.$window.location.href;

        // Strip of the base path, Yes big ass regex
        const regex = /(?:https?:\/\/)?(?:(?:[\w-]+\.[\w-]+\.[\w-]+)|(?:[\w-]+)(?:\:[0-9]{0,5}))(.*)/;
        return encodeURIComponent(regex.exec(loginRedirect)[1]);
    }
}
